/**
 * Scroll to a specific anchor tag (ID attribute) present on the template
 * @param id ID of the element `id="myId"`
 */
export function scrollToId(id: string): void {
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: 'smooth' });
}